import type { HTMLAttributes } from 'react';
import styles from './FieldRow.module.css';

export const FieldRow = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={[styles['row'], className ?? ''].join(' ')} {...rest} />
);
